import {
  QUIZ_SCORES,
  QUIZ_TIMES,
  activityIcon,
  lessonIcon,
} from "@/utils/constants";

import Button from "@/app/components/ui/Button";
import Dropdown from "@/app/components/ui/DropDown";
import icons from "@/assets/icons";
import { useState } from "react";

type initProps = {
  selectedQuiz?: Quiz;
  updatePageType: Function;
  updatePagePoints: Function;
  updatePageTime: Function;
  type: string;
  quizTypes?: SelectItem[];
  selectedSlide?: Slide;
  slideTypes?: SelectItem[];
  isDesktopOrLaptop: boolean;
};

export default function NavBar({
  selectedQuiz,
  updatePageType,
  updatePagePoints,
  updatePageTime,
  type,
  quizTypes: quizType,
  selectedSlide,
  slideTypes,
  isDesktopOrLaptop,
}: initProps) {
  const [scoreIsOpen, setScoreIsOpen] = useState(false);
  const [timeIsOpen, setTimeIsOpen] = useState(false);
  const [viewAllTypes, setViewAllTypes] = useState(false);

  const toggleViewTypes = () => {
    setViewAllTypes(!viewAllTypes);
  };
  return (
    <div className="w-full md:p-3 p-1 flex md:flex-row flex-col-reverse justify-between items-center rounded-xl bg-bg-cards relative">
      <div
        className={`flex  justify-start items-center gap-3 self-stretch${
          selectedQuiz && !isDesktopOrLaptop
            ? "  absolute z-50  top-16"
            : "top-1"
        }  `}
      >
        {type === "lesson" && selectedSlide && (
          <div className="flex p-3 items-start gap-[6px] rounded-lg bg-bg-cards2">
            {lessonIcon.map((item, index) => (
              <div key={index} title={item.title}>
                <Button
                  icon={item.icon}
                  styleClass={`${
                    selectedSlide &&
                    selectedSlide?.slide_type ===
                      slideTypes!.find((type) => type.code === item.slide_type)
                        ?.id
                      ? "bg-gray-0 px-2.5 py-2.5 border-2 border-solid border-gray-100  gap-2 rounded-xl "
                      : item.bg + " iconbutton"
                  }  p-1`}
                  iconHeight="h-[18px]"
                  iconWidth="w-[18px]"
                  handleClick={() => updatePageType(item.slide_type)}
                />
              </div>
            ))}
          </div>
        )}
        {(viewAllTypes || isDesktopOrLaptop) && selectedQuiz && (
          <div className="flex p-3 items-start gap-[6px] rounded-lg bg-bg-cards2">
            {activityIcon.map((item, index) => (
              <div key={index} title={item.title}>
                <Button
                  icon={item.icon}
                  styleClass={`${
                    selectedQuiz &&
                    selectedQuiz?.quiz_type ===
                      quizType!.find((type) => type.code === item.quiz_type)?.id
                      ? "bg-gray-0 px-2.5 py-2.5 border-2 border-solid border-gray-100  gap-2 rounded-xl"
                      : item.bg + " iconbutton"
                  }  p-1`}
                  iconHeight="h-5"
                  iconWidth="w-5"
                  handleClick={() => updatePageType(item.quiz_type)}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {selectedQuiz && (
        <div className="flex p-3 items-start gap-2 rounded-xl bg-bg-cards1 md:w-[296px] w-full ">
          {!isDesktopOrLaptop && (
            <Button
              icon={
                selectedQuiz &&
                activityIcon &&
                activityIcon.find(
                  (itm) =>
                    itm.quiz_type ===
                    quizType!.find(
                      (type) => type.id === selectedQuiz?.quiz_type,
                    )?.code,
                )?.icon
              }
              styleClass={` button
                   p-1`}
              iconHeight="h-5"
              iconWidth="w-5"
              handleClick={toggleViewTypes}
            />
          )}
          <div className="w-[2px] h-[58px]">{icons.vector}</div>
          <Dropdown
            title={""}
            icon={icons.score}
            items={QUIZ_SCORES}
            selectedItem={undefined}
            iconHeight="w-[18px]"
            iconWidth="w-[18px]"
            onChange={updatePagePoints}
            placeholder={
              selectedQuiz?.points ? selectedQuiz.points?.toString() : "امتیاز"
            }
            containsNull={true}
            open={scoreIsOpen}
            openCallBack={(e) => {
              setScoreIsOpen(e);
              if (e === true && timeIsOpen === true) setTimeIsOpen(false);
            }}
          />
          <Dropdown
            icon={icons.clock}
            items={QUIZ_TIMES}
            selectedItem={undefined}
            iconHeight="w-[18px]"
            iconWidth="w-[18px]"
            onChange={updatePageTime}
            placeholder={
              selectedQuiz && selectedQuiz.time
                ? (selectedQuiz.time / 60).toString() + " دقیقه"
                : "زمان"
            }
            title={""}
            containsNull={true}
            open={timeIsOpen}
            openCallBack={(e) => {
              setTimeIsOpen(e);
              if (e === true && scoreIsOpen === true) setScoreIsOpen(false);
            }}
          />
        </div>
      )}
    </div>
  );
}
